import { IStoreState } from "modules/types";

export const getselectLanguage = (state: IStoreState) =>
  state.language.selectLanguage;
